const urlName = '/usercenter/v1/account'

export default (API) => ({
/**
 * 获取登录用户信息
 * @param {} param0
 * 响应数据data
 */
getAccountUserInfo () {
    return API({ url: `${urlName}/getUserInfo`});
},
/**
   * 根据原密码修改密码
   * @param { } 
   * 响应数据data：  
   */
changePassword (  params ) {
    return API({ url: `${urlName}/changePassword`, method: 'post' , params });
  },
  /**
   * 验证身份
   * @param {} 
   * 响应数据data：  
   */
  checkAuthCode (  params ) {
    return API({ url: `${urlName}/checkAuthCode` , method: 'post' , params });
  },
  /**
   * 判断是否绑定手机号
   * 响应数据data：Boolean
   */
  judgeAccountIfBindPhone () {
    return API({ url: `${urlName}/judgeAccountIfBindPhone` });
  },
  /**
   * 判断是否绑定邮箱
   * 响应数据data：Boolean
   */
  judgeAccountIfBindMail () {
    return API({ url: `${urlName}/judgeAccountIfBindMail` });
  },
  /**
  * 获取已绑定手机
  * 响应数据data：String
  */
  getCurrentUserAccount () {
    return API({ url: `${urlName}/getCurrentUserAccount` });
  },
  /**
  * 获取已绑定邮箱
  * 响应数据data：String
  */
  getCurrentUserMail () {
    return API({ url: `${urlName}/getCurrentUserMail` });
  },
  /**
  * 绑定手机号、邮箱
  * 响应数据data
  */
  bindUserAccount (data) {
    return API({ url: `${urlName}/bindUserAccount`, method: 'post', data });
  },
  /**
  * 换绑手机号、邮箱
  * 响应数据data
  */
  unBindUserAccount (data) {
    return API({ url: `${urlName}/unBindUserAccount`, method: 'post', data });
  },
  /**
  * 换绑手机号、邮箱发送验证码
  * 响应数据data
  */
  getAuthCodePublic ({ params, data }) {
    return API({ url: `${urlName}/getAuthCodePublic`, method: 'post', params, data });
  },
})